<template>
  <main style="overflow: hidden;max-width: 100%;display: flex" class="content">
    <!-- content -->
    <div class="audience-bg"></div>
    <section class="youtube" style="width: 100%">
      <div class="container">
        <div class="youtube-wrapper">
          <h4 class="youtube__text">Бесплатные видеоуроки</h4>
          <div class="youtube-inner">
            <div class="youtube-swiper-container" id="id">
              <!-- Additional required wrapper -->
              <div class="youtube-swiper-wrapper" id="id1">
                <!-- Slides -->
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/dq87AJE2bF8"></iframe>
                  </div>
                  <h3 class="youtube-title">Оспариваем схему и возвращаем права за встречку</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/308">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/oPNO94w-86Q"></iframe>
                  </div>
                  <h3 class="youtube-title">Выиграть любое дело без юристов и адвокатов</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/310">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/gwL5oicSxcY"></iframe>
                  </div>
                  <h3 class="youtube-title">Досрочный возврат прав? Без обращения к юристам</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/315">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/vGdKViChjR4"></iframe>
                  </div>
                  <h3 class="youtube-title">Как исключить фото и видео из дела по встречке</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/309">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/AvL2FR5Dvow"></iframe>
                  </div>
                  <h3 class="youtube-title">Оспариваем акт освидетельствования и медосвидетельствования</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/307">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/p_vbrC51Ug8"></iframe>
                  </div>
                  <h3 class="youtube-title">Заставляем страховую компанию платить через омбудсмена</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/440">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
                <div class="youtube-swiper-slide youtube-item">
                  <div class="youtube-box">
                    <iframe src="https://www.youtube.com/embed/KVmRTXF01Jk"></iframe>
                  </div>
                  <h3 class="youtube-title">Как взыскать деньги с ГИБДД за незаконное привлечение к ответственности</h3>
                  <div class="youtube-btn-wrapper">
                    <router-link class="youtube-btn" to="/urist/program/34092">ЗАПИСАТЬСЯ</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-iptions youtube-swiper-iptions">
              <div class="youtube-swiper-button-prev"></div>
              <div class="youtube-swiper-pagination"></div>
              <div class="youtube-swiper-button-next"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'videos',
  methods: {
    initSliderFree () {
      let elem = document.getElementById('freeProgram')
      console.log(elem)
      if (elem == null) {
        document.getElementById('id').className += ' youtube-swiper-container-free'
        document.getElementById('id1').className += ' youtube-swiper-wrapper-free'
      }
    },
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  },
  mounted () {
    setTimeout(() => {
      this.initSliderFree()
    }, 2000)
  }
}
</script>

<style scoped>
    .youtube__text {
        font-size: 30px;
        text-align: center;
        font-family: "Montserrat";
        font-weight: 700;
        margin: 40px 0;

    }
    .youtube-box {
        width: 100%;
    }
    .youtube-box iframe {
        width: 100%;
        height: auto;

    }
    .youtube-title {
        font-size: 15px;
        font-weight: 500;
        margin: 10px auto;
        text-align: center;
        font-family: "Montserrat";
        min-height: 60px;
    }
    .youtube-btn-wrapper {
        margin-top: auto;
    }
    .youtube-btn {
        display: inline-block;
        padding: 8px 20px;
        background: -webkit-gradient(linear, left top, left bottom, from(#3064EA), to(#314F9C));
        background: -o-linear-gradient(top, #3064EA 0%, #314F9C 100%);
        background: linear-gradient(180deg, #3064EA 0%, #314F9C 100%);
        border-radius: 100px;
        color: #ffffff;
        font-family: "Montserrat";
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
    }
    @media (max-width: 767px) {
        .youtube-item {
        }
    }
    @media (max-width: 400px) {
        .youtube-item {
            margin-left: 0;
            margin-right: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/free.vue